// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { MobileAppstoreAssetsAreaId } from './MobileAppstoreAssetsAreaId'
import { MobileAppstoreAssetsAreaNavigation } from './MobileAppstoreAssetsAreaNavigation'
import { MobileAppstoreAssetsAreaRoutes } from './MobileAppstoreAssetsAreaRoutes'

const LazyMobileAppstoreAssetsComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./MobileAppstoreAssetsArea')),
)

const MobileAppstoreAssetsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyMobileAppstoreAssetsComponent />
  </SuspenseLoadingWrapper>
)

export const MobileAppstoreAssetsArea = {
  id: MobileAppstoreAssetsAreaId,
  requiredRight: BoumRight.AREA_MOBILE_APPSTORE_ASSETS,
  NavigationComponent: MobileAppstoreAssetsAreaNavigation,
  route: {
    path: MobileAppstoreAssetsAreaRoutes.route,
    component: MobileAppstoreAssetsComponent,
  },
}
